import { createFileRoute, Outlet } from "@tanstack/react-router";

import { useUser } from "@/web/auth/useUser";
import { Redirect } from "@/web/components/Redirect";

export const Route = createFileRoute("/_protected/admin")({
  component: RouteComponent,
});

function RouteComponent() {
  const user = useUser();

  // 404 on unauthorized (403 might be more appropriate)
  if (!user?.isWithcoEmployee) return <Redirect to="/$" />;

  return <Outlet />;
}
